/**
 * Thin error-shape helper condiviso (Task #2186).
 *
 * Equivalente lato shared del `toErr` backend (`packages/backend/src/utils/
 * error-utils.ts`), riusabile dai package frontend per instradare gli accessi a
 * proprietà su valori `catch (e: unknown)` senza reintrodurre `any`. Restituisce
 * una shape strutturata con i campi d'errore più comuni + index signature per il
 * resto.
 */
export interface ErrLike {
  name: string;
  message: string;
  stack?: string;
  code?: string | number;
  status?: number;
  statusCode?: number;
  response?: ErrLike;
  data?: unknown;
  errors?: unknown;
  cause?: unknown;
  details?: unknown;
  type?: string;
  reason?: unknown;
  [key: string]: unknown;
}

export function toErr(err: unknown): ErrLike {
  if (err && typeof err === 'object') {
    const e = err as Record<string, unknown>;
    const out: Record<string, unknown> = { ...e };
    out.name = typeof e.name === 'string' ? e.name : 'Error';
    out.message = typeof e.message === 'string' ? e.message : String(err);
    if (typeof e.stack === 'string') out.stack = e.stack;
    return out as ErrLike;
  }
  return { name: 'Error', message: String(err) };
}
